import * as classes from './classes/classNames';

export const secondHpTable = [
  {
    job: [classes.NOVICE, classes.SUPER_NOVICE],
    hpJobA: 0,
    hpJobB: 5,
  },
  {
    job: [classes.SWORDMAN, classes.HIGH_SWORDMAN, classes.TAEKWON_KID],
    hpJobA: 0.7,
    hpJobB: 5,
  },
  {
    job: [classes.MAGE, classes.HIGH_MAGICIAN],
    hpJobA: 0.3,
    hpJobB: 5,
  },
  {
    job: [
      classes.ACOLYTE,
      classes.HIGH_ACOLYTE,
      classes.MERCHANT,
      classes.HIGH_MERCHANT,
    ],
    hpJobA: 0.4,
    hpJobB: 5,
  },
  {
    job: [
      classes.THIEF,
      classes.HIGH_THIEF,
      classes.ARCHER,
      classes.HIGH_ARCHER,
    ],
    hpJobA: 0.5,
    hpJobB: 5,
  },
  {
    job: [classes.KNIGHT, classes.LORD_KNIGHT],
    hpJobA: 1.5,
    hpJobB: 5,
  },
  {
    job: [classes.WIZARD, classes.HIGH_WIZARD],
    hpJobA: 0.55,
    hpJobB: 5,
  },
  {
    job: [classes.PRIEST, classes.HIGH_PRIEST, classes.SAGE, classes.PROFESSOR],
    hpJobA: 0.75,
    hpJobB: 5,
  },
  {
    job: [classes.ASSASSIN, classes.ASSASSIN_CROSS],
    hpJobA: 1.1,
    hpJobB: 5,
  },
  {
    job: [
      classes.BLACKSMITH,
      classes.WHITESMITH,
      classes.ALCHEMIST,
      classes.CREATOR,
    ],
    hpJobA: 0.9,
    hpJobB: 5,
  },
  {
    job: [classes.HUNTER, classes.SNIPER, classes.ROGUE, classes.STALKER],
    hpJobA: 0.85,
    hpJobB: 5,
  },
  {
    job: [classes.CRUSADER, classes.PALADIN],
    hpJobA: 1.1,
    hpJobB: 7,
  },
  {
    job: [classes.MONK, classes.CHAMPION],
    hpJobA: 0.9,
    hpJobB: 6.5,
  },
  {
    job: [classes.BARD, classes.MINSTREL, classes.DANCER, classes.GYPSY],
    hpJobA: 0.75,
    hpJobB: 3,
  },
];

export const secondSpTable = [
  {
    job: [
      classes.SWORDMAN,
      classes.HIGH_SWORDMAN,
      classes.ACOLYTE,
      classes.HIGH_ACOLYTE,
      classes.THIEF,
      classes.HIGH_THIEF,
      classes.TAEKWON_KID,
    ],
    spJob: 2,
  },
  {
    job: [
      classes.ACOLYTE,
      classes.HIGH_ACOLYTE,
      classes.ROGUE,
      classes.STALKER,
    ],
    spJob: 5,
  },
  {
    job: [
      classes.MERCHANT,
      classes.HIGH_MERCHANT,
      classes.KNIGHT,
      classes.LORD_KNIGHT,
      classes.NINJA,
    ],
    spJob: 3,
  },
  {
    job: [
      classes.MAGE,
      classes.HIGH_MAGICIAN,
      classes.DANCER,
      classes.BARD,
      classes.MINSTREL,
      classes.GYPSY,
    ],
    spJob: 6,
  },
  {
    job: [
      classes.HUNTER,
      classes.SNIPER,
      classes.ASSASSIN,
      classes.ASSASSIN_CROSS,
      classes.BLACKSMITH,
      classes.WHITESMITH,
      classes.ALCHEMIST,
      classes.CREATOR,
      classes.TEAKWON_MASTER,
      classes.GUNSLINGER,
    ],
    spJob: 4,
  },
  {
    job: [classes.WIZARD, classes.HIGH_WIZARD, classes.SOUL_LINKER],
    spJob: 9,
  },
  {
    job: [classes.PRIEST, classes.HIGH_PRIEST],
    spJob: 8,
  },
  {
    job: [classes.CRUSADER, classes.PALADIN, classes.MONK, classes.CHAMPION],
    spJob: 4.7,
  },
  {
    job: [classes.SAGE, classes.PROFESSOR],
    spJob: 7,
  },
];

export const thirdHpTable = [
  {
    job: [classes.RUNE_KNIGHT],
    hpTable: [
      8100,
      8133,
      8242,
      8352,
      8464,
      8576,
      8690,
      8804,
      8920,
      9036,
      9154,
      9273,
      9393,
      9514,
      9636,
      9759,
      9883,
      10008,
      10134,
      10261,
      10389,
      10518,
      10648,
      10779,
      10912,
      11045,
      11180,
      11315,
      11452,
      11589,
      11728,
      11868,
      12009,
      12151,
      12294,
      12438,
      12583,
      12729,
      12876,
      13024,
      13173,
      13323,
      13474,
      13626,
      13780,
      13934,
      14090,
      14246,
      14404,
      14562,
      14722,
      14883,
      15042,
      15100,
      15260,
      15321,
      15481,
      15541,
      15600,
      15760,
      15820,
      15980,
      16141,
      16303,
      16466,
      16630,
      16795,
      16961,
      17128,
      17296,
      17465,
      17635,
      17806,
      17978,
      18151,
      18325,
      18500,
    ],
  },
  {
    job: [classes.GUILLOTINE_CROSS],
    hpTable: [
      6050,
      6093,
      6208,
      6324,
      6441,
      6559,
      6678,
      6798,
      6920,
      7043,
      7167,
      7292,
      7418,
      7545,
      7673,
      7802,
      7932,
      8063,
      8196,
      8330,
      8465,
      8601,
      8738,
      8876,
      9015,
      9155,
      9296,
      9438,
      9582,
      9727,
      9873,
      10020,
      10168,
      10317,
      10467,
      10618,
      10770,
      10923,
      11078,
      11234,
      11391,
      11549,
      11708,
      11868,
      12029,
      12191,
      12354,
      12518,
      12684,
      12851,
      13019,
      13188,
      13351,
      13518,
      13684,
      13850,
      14016,
      14182,
      14349,
      14515,
      14681,
      14830,
      14966,
      15103,
      15241,
      15380,
      15520,
      15661,
      15803,
      15946,
      16090,
      16235,
      16381,
      16528,
      16676,
      16825,
      16975,
    ],
  },
  {
    job: [classes.ARCH_BISHOP],
    hpTable: [
      4300,
      4333,
      4412,
      4491,
      4570,
      4649,
      4728,
      4807,
      4886,
      4965,
      5044,
      5123,
      5202,
      5281,
      5360,
      5439,
      5518,
      5597,
      5676,
      5755,
      5834,
      5913,
      5992,
      6071,
      6150,
      6229,
      6308,
      6387,
      6466,
      6545,
      6624,
      6703,
      6782,
      6861,
      6940,
      7019,
      7098,
      7177,
      7256,
      7335,
      7414,
      7493,
      7572,
      7651,
      7730,
      7809,
      7888,
      7967,
      8046,
      8125,
      8204,
      8283,
      8362,
      8441,
      8520,
      8599,
      8678,
      8757,
      8836,
      8915,
      8994,
      9115,
      9276,
      9438,
      9601,
      9765,
      9930,
      10096,
      10263,
      10431,
      10600,
      10770,
      10941,
      11113,
      11286,
      11460,
      11635,
    ],
  },
  {
    job: [classes.RANGER],
    hpTable: [
      4800,
      4828,
      4918,
      5009,
      5101,
      5194,
      5288,
      5382,
      5477,
      5573,
      5670,
      5768,
      5867,
      5967,
      6068,
      6170,
      6273,
      6377,
      6482,
      6588,
      6694,
      6801,
      6909,
      7018,
      7128,
      7239,
      7351,
      7464,
      7578,
      7693,
      7809,
      7926,
      8044,
      8162,
      8281,
      8401,
      8522,
      8644,
      8767,
      8891,
      9016,
      9142,
      9269,
      9397,
      9526,
      9656,
      9786,
      9917,
      10049,
      10182,
      10316,
      10451,
      10585,
      10719,
      10853,
      10987,
      11121,
      11255,
      11389,
      11523,
      11657,
      11790,
      11926,
      12063,
      12201,
      12340,
      12480,
      12621,
      12763,
      12906,
      13050,
      13195,
      13341,
      13488,
      13636,
      13785,
      13935,
    ],
  },
  {
    job: [classes.WARLOCK],
    hpTable: [
      3200,
      3313,
      3383,
      3455,
      3528,
      3601,
      3675,
      3749,
      3824,
      3899,
      3975,
      4051,
      4129,
      4208,
      4287,
      4367,
      4447,
      4528,
      4609,
      4691,
      4773,
      4857,
      4941,
      5026,
      5112,
      5198,
      5285,
      5372,
      5460,
      5548,
      5638,
      5728,
      5819,
      5911,
      6003,
      6096,
      6189,
      6283,
      6377,
      6473,
      6569,
      6666,
      6763,
      6861,
      6960,
      7059,
      7159,
      7259,
      7361,
      7463,
      7566,
      7669,
      7771,
      7874,
      7976,
      8079,
      8181,
      8284,
      8386,
      8489,
      8591,
      8730,
      8891,
      9053,
      9216,
      9380,
      9545,
      9711,
      9878,
      10046,
      10215,
      10385,
      10556,
      10728,
      10901,
      11075,
      11250,
    ],
  },
  {
    job: [classes.ROYAL_GUARD],
    hpTable: [
      6050,
      6093,
      6208,
      6324,
      6441,
      6559,
      6678,
      6798,
      6920,
      7043,
      7167,
      7292,
      7418,
      7545,
      7673,
      7802,
      7932,
      8063,
      8196,
      8330,
      8465,
      8601,
      8738,
      8876,
      9015,
      9155,
      9296,
      9438,
      9582,
      9727,
      9873,
      10020,
      10168,
      10317,
      10467,
      10618,
      10770,
      10923,
      11078,
      11234,
      11391,
      11549,
      11708,
      11868,
      12029,
      12191,
      12354,
      12518,
      12684,
      12851,
      13019,
      13188,
      13355,
      13522,
      13690,
      13857,
      14025,
      14192,
      14360,
      14527,
      14695,
      14860,
      15021,
      15183,
      15346,
      15510,
      15675,
      15841,
      16008,
      16176,
      16345,
      16515,
      16686,
      16858,
      17031,
      17205,
      17380,
    ],
  },
  {
    job: [classes.MECHANIC],
    hpTable: [
      5807,
      5844,
      5952,
      6061,
      6172,
      6283,
      6396,
      6510,
      6625,
      6741,
      6857,
      6974,
      7093,
      7212,
      7333,
      7455,
      7578,
      7702,
      7828,
      7954,
      8081,
      8208,
      8337,
      8467,
      8598,
      8730,
      8864,
      8998,
      9134,
      9271,
      9408,
      9546,
      9685,
      9825,
      9967,
      10109,
      10253,
      10398,
      10544,
      10691,
      10838,
      10987,
      11136,
      11287,
      11439,
      11592,
      11746,
      11901,
      12057,
      12215,
      12372,
      12531,
      12688,
      12845,
      13003,
      13160,
      13318,
      13475,
      13633,
      13790,
      13948,
      14105,
      14266,
      14428,
      14591,
      14755,
      14920,
      15086,
      15253,
      15421,
      15590,
      15760,
      15931,
      16103,
      16276,
      16450,
      16625,
    ],
  },
  {
    job: [classes.SHADOW_CHASER],
    hpTable: [
      6050,
      6093,
      6208,
      6324,
      6441,
      6559,
      6678,
      6798,
      6920,
      7043,
      7167,
      7292,
      7418,
      7545,
      7673,
      7802,
      7932,
      8063,
      8196,
      8330,
      8465,
      8601,
      8738,
      8876,
      9015,
      9155,
      9296,
      9438,
      9582,
      9727,
      9873,
      10020,
      10168,
      10317,
      10467,
      10618,
      10770,
      10923,
      11078,
      11234,
      11391,
      11549,
      11708,
      11868,
      12029,
      12191,
      12354,
      12518,
      12684,
      12851,
      13019,
      13188,
      13300,
      13420,
      13500,
      13600,
      13700,
      13800,
      13900,
      14000,
      14100,
      14200,
      14301,
      14403,
      14506,
      14610,
      14715,
      14821,
      14928,
      15036,
      15145,
      15255,
      15366,
      15478,
      15591,
      15705,
      15820,
    ],
  },
  {
    job: [classes.SURA],
    hpTable: [
      5050,
      5082,
      5176,
      5271,
      5367,
      5464,
      5562,
      5661,
      5761,
      5862,
      5963,
      6065,
      6168,
      6272,
      6377,
      6483,
      6590,
      6698,
      6807,
      6917,
      7027,
      7138,
      7250,
      7363,
      7477,
      7592,
      7708,
      7825,
      7943,
      8062,
      8181,
      8301,
      8422,
      8544,
      8667,
      8791,
      8916,
      9042,
      9169,
      9297,
      9425,
      9554,
      9684,
      9815,
      9947,
      10080,
      10214,
      10349,
      10485,
      10622,
      10759,
      10897,
      11033,
      11170,
      11307,
      11444,
      11581,
      11718,
      11855,
      11992,
      12129,
      12265,
      12406,
      12548,
      12691,
      12835,
      12980,
      13126,
      13273,
      13421,
      13570,
      13720,
      13871,
      14023,
      14176,
      14330,
      14485,
    ],
  },
  {
    job: [classes.WANDERER, classes.MAESTRO],
    hpTable: [
      4800,
      4828,
      4918,
      5009,
      5101,
      5194,
      5288,
      5382,
      5477,
      5573,
      5670,
      5768,
      5867,
      5967,
      6068,
      6170,
      6273,
      6377,
      6482,
      6588,
      6694,
      6801,
      6909,
      7018,
      7128,
      7239,
      7351,
      7464,
      7578,
      7693,
      7809,
      7926,
      8044,
      8162,
      8281,
      8401,
      8522,
      8644,
      8767,
      8891,
      9016,
      9142,
      9269,
      9397,
      9526,
      9656,
      9786,
      9917,
      10049,
      10182,
      10316,
      10451,
      10584,
      10717,
      10851,
      10984,
      11118,
      11251,
      11385,
      11518,
      11652,
      11785,
      11921,
      12058,
      12196,
      12335,
      12475,
      12616,
      12758,
      12901,
      13045,
      13190,
      13336,
      13483,
      13631,
      13780,
      13930,
    ],
  },
  {
    job: [classes.SORCERER],
    hpTable: [
      4080,
      4103,
      4180,
      4257,
      4335,
      4414,
      4494,
      4574,
      4655,
      4737,
      4819,
      4902,
      4986,
      5071,
      5157,
      5244,
      5332,
      5420,
      5509,
      5599,
      5689,
      5780,
      5872,
      5965,
      6058,
      6153,
      6248,
      6344,
      6441,
      6539,
      6637,
      6737,
      6837,
      6937,
      7038,
      7140,
      7243,
      7347,
      7451,
      7557,
      7663,
      7770,
      7878,
      7987,
      8097,
      8207,
      8318,
      8429,
      8541,
      8654,
      8768,
      8883,
      8994,
      9107,
      9220,
      9280,
      9340,
      9450,
      9570,
      9680,
      9798,
      9915,
      10036,
      10158,
      10281,
      10405,
      10530,
      10656,
      10783,
      10911,
      11040,
      11170,
      11301,
      11433,
      11566,
      11700,
      11835,
    ],
  },
  {
    job: [classes.GENETIC],
    hpTable: [
      4730,
      4766,
      4853,
      4940,
      5027,
      5113,
      5200,
      5287,
      5374,
      5461,
      5548,
      5635,
      5722,
      5809,
      5896,
      5982,
      6069,
      6156,
      6243,
      6330,
      6417,
      6504,
      6591,
      6678,
      6765,
      6851,
      6938,
      7025,
      7112,
      7199,
      7286,
      7373,
      7460,
      7547,
      7634,
      7720,
      7807,
      7894,
      7981,
      8068,
      8155,
      8242,
      8329,
      8416,
      8503,
      8589,
      8676,
      8763,
      8850,
      8937,
      9024,
      9111,
      9198,
      9285,
      9372,
      9459,
      9546,
      9633,
      9720,
      9807,
      9894,
      9980,
      10141,
      10303,
      10466,
      10630,
      10795,
      10961,
      11128,
      11296,
      11465,
      11635,
      11806,
      11978,
      12151,
      12325,
      12500,
    ],
  },
];

export const thirdSpTable = [
  {
    job: [classes.RUNE_KNIGHT],
    spTable: [
      300,
      310,
      313,
      316,
      319,
      322,
      325,
      328,
      331,
      334,
      337,
      340,
      343,
      346,
      349,
      352,
      355,
      358,
      361,
      364,
      367,
      370,
      373,
      376,
      379,
      382,
      385,
      388,
      391,
      394,
      397,
      400,
      403,
      406,
      409,
      412,
      415,
      418,
      421,
      424,
      427,
      430,
      433,
      436,
      439,
      442,
      445,
      448,
      451,
      454,
      457,
      460,
      500,
      566,
      629,
      672,
      710,
      748,
      781,
      824,
      847,
      890,
      894,
      898,
      902,
      906,
      910,
      915,
      920,
      925,
      930,
      935,
      941,
      947,
      953,
      959,
      965,
    ],
  },
  {
    job: [classes.GUILLOTINE_CROSS],
    spTable: [
      400,
      410,
      414,
      418,
      422,
      426,
      430,
      434,
      438,
      442,
      446,
      450,
      454,
      458,
      462,
      466,
      470,
      474,
      478,
      482,
      486,
      490,
      494,
      498,
      502,
      506,
      510,
      514,
      518,
      522,
      526,
      530,
      534,
      538,
      542,
      546,
      550,
      554,
      558,
      562,
      566,
      570,
      574,
      578,
      582,
      586,
      590,
      594,
      598,
      602,
      606,
      610,
      670,
      695,
      700,
      715,
      730,
      745,
      760,
      785,
      790,
      805,
      810,
      815,
      820,
      825,
      830,
      836,
      842,
      848,
      854,
      860,
      867,
      874,
      881,
      888,
      895,
    ],
  },
  {
    job: [classes.ARCH_BISHOP],
    spTable: [
      800,
      810,
      818,
      826,
      834,
      842,
      850,
      858,
      866,
      874,
      882,
      890,
      898,
      906,
      914,
      922,
      930,
      938,
      946,
      954,
      962,
      970,
      978,
      986,
      994,
      1002,
      1010,
      1018,
      1026,
      1034,
      1042,
      1050,
      1058,
      1066,
      1074,
      1082,
      1090,
      1098,
      1106,
      1114,
      1122,
      1130,
      1138,
      1146,
      1154,
      1162,
      1170,
      1178,
      1186,
      1194,
      1202,
      1210,
      1258,
      1286,
      1334,
      1372,
      1410,
      1458,
      1466,
      1474,
      1482,
      1490,
      1499,
      1508,
      1517,
      1526,
      1535,
      1545,
      1555,
      1565,
      1575,
      1585,
      1596,
      1607,
      1618,
      1629,
      1640,
    ],
  },
  {
    job: [classes.RANGER],
    spTable: [
      400,
      410,
      414,
      418,
      422,
      426,
      430,
      434,
      438,
      442,
      446,
      450,
      454,
      458,
      462,
      466,
      470,
      474,
      478,
      482,
      486,
      490,
      494,
      498,
      502,
      506,
      510,
      514,
      518,
      522,
      526,
      530,
      534,
      538,
      542,
      546,
      550,
      554,
      558,
      562,
      566,
      570,
      574,
      578,
      582,
      586,
      590,
      594,
      598,
      602,
      606,
      610,
      650,
      675,
      680,
      695,
      710,
      725,
      740,
      765,
      770,
      785,
      790,
      795,
      800,
      805,
      810,
      816,
      822,
      828,
      834,
      840,
      847,
      854,
      861,
      868,
      875,
    ],
  },
  {
    job: [classes.WARLOCK, classes.SORCERER, classes.GENETIC],
    spTable: [
      900,
      910,
      919,
      928,
      937,
      946,
      955,
      964,
      973,
      982,
      991,
      1000,
      1009,
      1018,
      1027,
      1036,
      1045,
      1054,
      1063,
      1072,
      1081,
      1090,
      1099,
      1108,
      1117,
      1126,
      1135,
      1144,
      1153,
      1162,
      1171,
      1180,
      1189,
      1198,
      1207,
      1216,
      1225,
      1234,
      1243,
      1252,
      1261,
      1270,
      1279,
      1288,
      1297,
      1306,
      1315,
      1324,
      1333,
      1342,
      1351,
      1360,
      1369,
      1378,
      1387,
      1396,
      1405,
      1414,
      1423,
      1432,
      1441,
      1450,
      1460,
      1470,
      1480,
      1490,
      1500,
      1511,
      1522,
      1533,
      1544,
      1555,
      1567,
      1579,
      1591,
      1603,
      1615,
    ],
  },
  {
    job: [classes.MECHANIC, classes.ROYAL_GUARD],
    spTable: [
      400,
      410,
      414,
      418,
      422,
      426,
      430,
      434,
      438,
      442,
      446,
      450,
      454,
      458,
      462,
      466,
      470,
      474,
      478,
      482,
      486,
      490,
      494,
      498,
      502,
      506,
      510,
      514,
      518,
      522,
      526,
      530,
      534,
      538,
      542,
      546,
      550,
      554,
      558,
      562,
      566,
      570,
      574,
      578,
      582,
      586,
      590,
      594,
      598,
      602,
      606,
      610,
      700,
      760,
      820,
      880,
      930,
      965,
      1020,
      1132,
      1160,
      1230,
      1235,
      1240,
      1245,
      1250,
      1255,
      1261,
      1267,
      1273,
      1279,
      1285,
      1292,
      1299,
      1306,
      1313,
      1320,
    ],
  },
  {
    job: [classes.SHADOW_CHASER, classes.SURA],
    spTable: [
      400,
      410,
      414,
      418,
      422,
      426,
      430,
      434,
      438,
      442,
      446,
      450,
      454,
      458,
      462,
      466,
      470,
      474,
      478,
      482,
      486,
      490,
      494,
      498,
      502,
      506,
      510,
      514,
      518,
      522,
      526,
      530,
      534,
      538,
      542,
      546,
      550,
      554,
      558,
      562,
      566,
      570,
      574,
      578,
      582,
      586,
      590,
      594,
      598,
      602,
      606,
      610,
      614,
      618,
      622,
      626,
      630,
      634,
      638,
      642,
      646,
      650,
      655,
      660,
      665,
      670,
      675,
      681,
      687,
      693,
      699,
      705,
      712,
      719,
      726,
      733,
      740,
    ],
  },
  {
    job: [classes.WANDERER, classes.MAESTRO],
    spTable: [
      400,
      410,
      414,
      418,
      422,
      426,
      430,
      434,
      438,
      442,
      446,
      450,
      454,
      458,
      462,
      466,
      470,
      474,
      478,
      482,
      486,
      490,
      494,
      498,
      502,
      506,
      510,
      514,
      518,
      522,
      526,
      530,
      534,
      538,
      542,
      546,
      550,
      554,
      558,
      562,
      566,
      570,
      574,
      578,
      582,
      586,
      590,
      594,
      598,
      602,
      606,
      610,
      614,
      648,
      702,
      726,
      750,
      774,
      808,
      822,
      846,
      850,
      855,
      860,
      865,
      870,
      875,
      881,
      887,
      893,
      899,
      905,
      912,
      919,
      926,
      933,
      940,
    ],
  },
];
